import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

  
import Preloader from "./components/Preloader";
import Home from "./pages/Home";
import GetInTouch from "./pages/GetInTouch";
import RecentWork from "./pages/RecentWork";
import Website from "./pages/Website";
import ScrollToTop from "./components/ScrollToTop";
import DigitalMarketing from "./pages/DigitalMarketing";
import ContentAndCreative from "./pages/ContentAndCreative";
import AnalyticsInsights from "./pages/AnalyticsInsights";
import PaidMediaPerfomance from "./pages/PaidMediaPerfomance";
import NotFound from "./pages/NotFound";
import Invoice from "./pages/Invoice";
import EnquiryForm from "./pages/EnquiryForm";
import BookingForm from "./pages/BookingForm";
import Terms from "./pages/Terms";
import About from "./pages/About";
import Crm from "./pages/Crm";
import PrivacyPolicy from "./pages/PrivacyPolicy";
 
function App() {
  const [loading, setLoading] = useState(true);

  const handleAnimationComplete = () => {
    setLoading(false);
  };

  return (
    <Router>
      <div className="App">
        {loading ? (
          <>
            <div className="loading-overlay">
              <div className="spinner"></div>
            </div>
            <Preloader onAnimationComplete={handleAnimationComplete} />
          </>
        ) : (
          <>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/get-in-touch" element={<GetInTouch />} />
              <Route path="/booking-form" element={<BookingForm />} />
              <Route path="/enquiry-form" element={<EnquiryForm />} />
              <Route path="/recent-work" element={<RecentWork />} />
              <Route path="/website" element={<Website />} />
              <Route path="/crm" element={<Crm />} />
             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/digital-marketing" element={<DigitalMarketing />} />
              <Route path="/invoice-generator" element={<Invoice />} />
              <Route
                path="/digital-marketing/services/content-creative"
                element={<ContentAndCreative />}
              />
              <Route
                path="/digital-marketing/services/analytics-insights"
                element={<AnalyticsInsights />}
              />
              <Route
                path="/digital-marketing/services/paid-media-performance"
                element={<PaidMediaPerfomance />}
              />
               <Route path="/about-us" element={< About />} />
             
              <Route path="/terms" element={<Terms />} />
              
              <Route path="*" element={<NotFound />} />
           
            </Routes>

            {/* ✅ Toast notifications */}
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />

        
          </>
        )}
      </div>
    </Router>
  );
}

export default App;
